import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import ReportsGenerator from "@/store/modules/reports/reportsGenerator";
import AutomaticReports from "@/store/modules/reports/automaticReports";
import ReportsBSP from "@/store/modules/reports/reportsBSP";
import { ReportTree } from "@/models/api/report/Report";
import { getReportTree } from "@/requests/report/report";
import { FILTER_NAMES } from "@/static/filterNames";
import i18n from "@/plugins/i18n";
export interface ReportsStateInterface {
  reportTree: Array<ReportTree>;
  activeReportType: Array<number>;
  activeReportFilterName: FILTER_NAMES | null;
  activeReportGeneratorTypes: Array<string>;
  activeReportGeneratorType: string | null;
  culture: string;
}

export const ReportsState: ReportsStateInterface = {
  reportTree: [],
  activeReportType: [],
  activeReportFilterName: null,
  activeReportGeneratorTypes: [],
  activeReportGeneratorType: null,
  culture: i18n.locale == "pl" ? "pl-PL" : "en-GB",
};

const ReportsModule = defineModule({
  state: ReportsState as ReportsStateInterface,
  namespaced: true as const,
  modules: {
    automaticReports: AutomaticReports,
    reportsGenerator: ReportsGenerator,
    reportsBSP: ReportsBSP,
  },
  getters: {},
  mutations: {
    setReportTree(state, param: Array<ReportTree>) {
      state.reportTree = param;
    },
    setActiveReportType(state, param: Array<number>) {
      state.activeReportType = param;
    },
    setActiveReportFilterName(state, param: FILTER_NAMES | null) {
      state.activeReportFilterName = param;
    },
    setActiveReportGeneratorTypes(state, param: Array<string>) {
      state.activeReportGeneratorTypes = param;
    },
    setActiveReportGeneratorType(state, param: string | null) {
      state.activeReportGeneratorType = param;
    },
    setCulture(state, param: string) {
      state.culture = param;
    },
  },
  actions: {
    async downloadTree(context) {
      const { commit } = _moduleActionContext(context);
      const reportTree = await getReportTree();
      commit.setReportTree(reportTree);
    },
    async setVariables(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.activeReportType.length == 0) {
        commit.setActiveReportFilterName(null);
        commit.setActiveReportGeneratorTypes([]);
        commit.setActiveReportGeneratorType(null);
      } else {
        state.reportTree.every((x) => {
          const temp = x.children.find((x) => x.id == state.activeReportType[0]);
          if (temp !== undefined) {
            if (temp.filterName === null) {
              commit.setActiveReportFilterName(null);
              commit.setActiveReportGeneratorTypes([]);
              commit.setActiveReportGeneratorType(null);
            } else {
              commit.setActiveReportFilterName(null); // filter name change not supported while filter component is loaded
              commit.setActiveReportFilterName(temp.filterName as FILTER_NAMES);
              commit.setActiveReportGeneratorTypes(temp.generatorTypes);
              commit.setActiveReportGeneratorType(temp.generatorTypes[0]);
            }
            return false;
          }
          return true;
        });
      }
    },
  },
});

export default ReportsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, ReportsModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, ReportsModule);
